import * as React from 'react';

import { uniq } from 'lodash';

import { CartSeat } from '../../../classes/seat';
import { tryCheckout, closeCartRemovalModal } from '../../../cart/actions/cart-actions';
import { Dispatch } from 'redux';
import { getCurrencyFormat } from '../../../helpers/currency-format';
import { Seat } from '../../../classes/seat';
import { getCurrentLanguage } from '../../../helpers/window-helpers';
import { ItemType } from '../../../classes/item-type';
import { SeatingOptionGroup } from '../../../classes/seating-option';
import { Html } from '../../../helpers/html-helpers';
import SubtotalItems from './subtotal-items';
import * as isEqual from 'react-fast-compare';


export interface ICartProps {
    dispatch: any /*Dispatch<any>*/;
    itemId: number;
    itemType: ItemType;
    allowExchangesAddon: boolean;

    selectedAdditionalOptionGroups: Array<SeatingOptionGroup>; //used for non-seat bound seating options

    cartCheckoutButton: string;
    cartAddMoreButton: string;
    cartDisabled: boolean;

    additionalNotes: string;

    cartMessage: string;
    //CartItems props
    cartSeats: Array<CartSeat>;
    cartSubtotalLabel: string;
    currencyFormat: string;
    exchangeFreeLabel: string;
}

interface ICartInteractionState {
    mobileCartOpen: boolean;
}

class Subtotal extends React.Component<ICartProps, ICartInteractionState>{
    constructor(props) {
        super(props);
        this.state = {
            mobileCartOpen: false,
        }
    }

    shouldComponentUpdate(nextProps: ICartProps, nextState) {
        return this.props.cartSeats.length != nextProps.cartSeats.length
            || this.props.cartDisabled != nextProps.cartDisabled
            || this.props.selectedAdditionalOptionGroups.length != nextProps.selectedAdditionalOptionGroups.length
            || this.props.additionalNotes != nextProps.additionalNotes
            || isEqual(this.props.cartSeats.map(s => s.selectedPricing.priceTypeId), nextProps.cartSeats.map(s => s.selectedPricing.priceTypeId));

    }

    render() {

        return (
            <div className="overlay-section-subtotal-container">

                {this.props.cartMessage.length > 0 ?
                    Html.renderParagraph(this.props.cartMessage, "caption-paragraph") : null
                }
                <SubtotalItems {...this.props} />

                <div className="cart-mini-cta">
                    {this.props.itemType === ItemType.Exchange && this.props.allowExchangesAddon ?
                        <button className={"cart-mini-cta-btn-primary" + (this.props.cartSeats.length === 0 || this.props.cartDisabled ? " disabled" : "")}
                            onClick={this._onAddMoreCheckoutClick.bind(this)}>
                            {this.props.cartAddMoreButton}
                        </button> : null
                    }
                    <button className={"cart-mini-cta-btn-primary" + (this.props.cartSeats.length === 0 || this.props.cartDisabled ? " disabled" : "")}
                        onClick={this._onCheckoutClick.bind(this)}>
                        {this.props.cartCheckoutButton}
                    </button>
                </div>
            </div>
        );
    }

    _onCheckoutClick() {
        this.props.dispatch(tryCheckout(this.props.cartSeats, this.props.selectedAdditionalOptionGroups, this.props.additionalNotes, this.props.itemId, false));
    }

    _onAddMoreCheckoutClick() {
        this.props.dispatch(tryCheckout(this.props.cartSeats, this.props.selectedAdditionalOptionGroups, this.props.additionalNotes, this.props.itemId, true));
    }



}

export default Subtotal;